import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    limitWhatIsIncludedContainer: {
    },
    title: {
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.tighter,
        fontWeight: theme.fontWeight.bold,
        marginBottom: theme.spacing[4],
        color: theme.colors.grey600
    },
    limit: {
        '& li:nth-of-type(n+3)': {
            display: 'none'
        }
    },
    content: {
        '& li': {
            listStyleType: 'disc',
            listStylePosition: 'outside',
            marginLeft: theme.spacing[8]
        },
        paddingLeft: theme.spacing[16],
        fontSize: theme.fontSize.sm,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey800,
        // reason: virgin returns extra <p> to sibling of <ul>
        '& p:nth-child(n+2)': {
            display: 'none'
        }
    }
}));

const LimitWhatIsIncluded = React.forwardRef((props, ref) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { inclusions, removeTitle, removelLimit, productId } = props;

    return (
        <div className={classes.limitWhatIsIncludedContainer}>
            {!removeTitle && <Typography className={classes.title}>WHAT'S INCLUDED</Typography>}
            <div ref={ref}
                id={removelLimit ? `${productId}-all-included` : getLimitWhatIsIncludedElementId(productId)}
                dangerouslySetInnerHTML={{ __html: inclusions }}
                className={classNames(classes.content, !removelLimit && classes.limit)}
            />
        </div>
    );
});

const getLimitWhatIsIncludedElementId = (productId) => {
    return `what-is-included-for-${productId}`;
};

LimitWhatIsIncluded.propTypes = {
    inclusions: PropTypes.string,
    removeTitle: PropTypes.bool,
    removelLimit: PropTypes.bool,
    productId: PropTypes.string
};

export { LimitWhatIsIncluded, getLimitWhatIsIncludedElementId };
